// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-CompanyDetails-Plans-styles___paper--h9jdn {
  padding: 32px;
  max-width: 736px;
  margin: 0 0 30px;
}

.components-CompanyDetails-Plans-styles___plansSectionHeader--nprUg {
  display: flex;
  align-items: center;
}

.components-CompanyDetails-Plans-styles___plansSectionHeaderText--AY0Mi {
  margin-left: 22px;
}

.components-CompanyDetails-Plans-styles___plansSectionHeaderText--AY0Mi h2 {
  font-size: 21px;
  color: #1b2432;
  letter-spacing: 0;
  margin-bottom: 5px;
}

.components-CompanyDetails-Plans-styles___plansSectionHeaderText--AY0Mi .components-CompanyDetails-Plans-styles___description--ZzrHH {
  font-size: 15px;
  color: #6d717a;
  letter-spacing: 0;
  margin-top: 8px;
}

.components-CompanyDetails-Plans-styles___plansSectionHeaderIconContainer--KdqBv {
  background: #1b2432;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./components/CompanyDetails/Plans/styles.pcss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":[".paper {\n  padding: 32px;\n  max-width: 736px;\n  margin: 0 0 30px;\n}\n\n.plansSectionHeader {\n  display: flex;\n  align-items: center;\n}\n\n.plansSectionHeaderText {\n  margin-left: 22px;\n}\n\n.plansSectionHeaderText h2 {\n  font-size: 21px;\n  color: #1b2432;\n  letter-spacing: 0;\n  margin-bottom: 5px;\n}\n\n.plansSectionHeaderText .description {\n  font-size: 15px;\n  color: #6d717a;\n  letter-spacing: 0;\n  margin-top: 8px;\n}\n\n.plansSectionHeaderIconContainer {\n  background: #1b2432;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paper": `components-CompanyDetails-Plans-styles___paper--h9jdn`,
	"plansSectionHeader": `components-CompanyDetails-Plans-styles___plansSectionHeader--nprUg`,
	"plansSectionHeaderText": `components-CompanyDetails-Plans-styles___plansSectionHeaderText--AY0Mi`,
	"description": `components-CompanyDetails-Plans-styles___description--ZzrHH`,
	"plansSectionHeaderIconContainer": `components-CompanyDetails-Plans-styles___plansSectionHeaderIconContainer--KdqBv`
};
module.exports = ___CSS_LOADER_EXPORT___;
